<script lang="ts">
export default {
  name: 'KkAccountInfoLabel',
}
</script>
<script setup lang="ts">
import {
  KkAccountImageWithIcon
} from '../../../../components/domains/sns'
interface Props {
  imageUrl: string
  snsType: string
  name: string
  pageId: string
}
const props = withDefaults(defineProps<Props>(), {
  imageUrl: '',
  snsType: '',
  name: '',
  pageId: ''
})
</script>
<template>
  <div class="accountInfoLabel">
    <KkAccountImageWithIcon
      :image-url="props.imageUrl"
      :sns-type="props.snsType"
    />
    <div class="accountInfoLabel__contents">
      {{ props.name }}
      <div class="accountInfoLabel__pageId">@{{ props.pageId }}</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.accountInfoLabel {
  display: flex;
  &__contents {
    margin-top: -4px;
    font-size: 14px;
  }
  &__pageId {
    font-size: 12px;
    color: #9e9e9e;
  }
}
</style>
